<template>
  <Loader v-if="loading" />
  <!-- <TabView @tab-click="onClickTab"> -->
  <TabView>

    <TabPanel header="Ricerca fornitura">
      <div class="forniture-contrattualizzate">
        <div class="header-section">
          <h2 class="page-title">Forniture contrattualizzate</h2>
          <p class="subtitle">Ricerca la fornitura da sbloccare</p>
        </div>
        
        <div class="action-section">
          <Button label="Scarica PdP switchabili" icon="pi pi-download" @click="downloadSwitchable" class="download-btn"/>
        </div>
        
        <div class="form-section">
          <div class="section-header">
            <h3>Ricerca Fornitura</h3>
          </div>
          
          <div class="form-container">
            <div class="form-group">
              <div class="supply-type-selector">
                <SelectButton v-model="selectedSupply" :options="options" aria-labelledby="basic" @update:modelValue="initData()"/>
              </div>
            </div>
            
            <div class="form-group">
              <div class="search-bar">
                <InputMask v-if="selectedSupply == 'Pod'" v-model="supply_ee" mask="aa999a9999999*" :placeholder="getPlaceholder" autofocus slotChar="" class="w-full"/>
                <InputMask v-if="selectedSupply == 'Pdr'" v-model="supply_gas" mask="99999999999999" :placeholder="getPlaceholder" autofocus slotChar="" class="w-full"/>
                <Button icon="pi pi-search" v-tooltip="`Ricerca fornitura`" v-if="canSearch" @click="searchSupply"/>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="has_items" class="results-section">
          <div class="section-header">
            <h3>Risultati fornitura: <span class="supply-id">{{ selectedSupply == 'Pod' ? supply_ee.toUpperCase() : supply_gas }}</span></h3>
          </div>
          
          <div class="form-container">
            <div class="form-group caricabile-toggle">
              <label class="form-label">Caricabile</label>
              <div class="toggle-container">
                <Checkbox v-model="is_caricabile" :binary="true"/>
                <Button v-tooltip="getTooltip()" icon="pi pi-send" v-if="is_caricabile_stato_iniziale != is_caricabile" @click="setSupply()"/>
              </div>
              <div class="status-messages" v-if="blacklist">
                <InlineMessage :severity="warn">in blacklist per credito ko dal {{moment(blacklist.data_inserimento).format('DD/MM/YYYY H:mm')}}</InlineMessage>
              </div>
            </div>

            <div class="status-messages" v-if="items[0].in_ask">
              <InlineMessage :severity="getSeverityInlineMessage(items[0])">{{getInlineMessage(items[0])}}</InlineMessage>
            </div>
            
            <DataTable :value="items" stripedRows>
                <Column field="matrice_id" header="#">
                    <template #body="{data}">
                        <Button class="cliente-btn" :label="data.matrice_id" @click="goToCaricamento($event, data)"/>
                    </template>
                </Column>
              <Column header="Data Caricamento">
                <template #body="{data}">
                  {{ moment(data.data_caricamento).format('DD/MM/Y H:mm:ss') }}
                </template>
              </Column>
              <Column field="nome_stato_caricamento" header="Stato Caricamento"></Column>
              <Column header="Cliente">
                <template #body="{data}">
                  <Button class="cliente-btn" :label="data.nome_cliente" @click="goTo($event, data, 'cliente')"/>
                </template>
              </Column>
              <Column header="Data ultima validazione">
                <template #body="{data}">
                  {{ data.data_ultima_validazione ? moment(data.data_ultima_validazione).format('DD-MM-YYYY HH:mm') : 'Non presente' }}
                </template>
              </Column>
              <Column header="Stato switch">
                <template #body="{data}">
                  {{ data.has_switch ? getStateSwitch(data) : 'Non presente' }}
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
      
    </TabPanel>
    <!-- <TabPanel header="Statistiche">
      <div class="flex justify-content-center">
        <Calendar v-model="date" view="month" dateFormat="mm/yy" @update:modelValue="getStatistiche()"/>
      </div>
      <div v-if="statistiche">
        <div class="card">
          Totale caricamenti: {{ statistiche.count_caricamenti }}
        </div>
        <div class="card">
          <Accordion>
            <AccordionTab header="Caricamenti">
              <Accordion :activeIndex="0">
                <AccordionTab v-for="caricamento in statistiche.caricamenti" :key="caricamento.id" :header="`#${caricamento.id}`">
                  <div class="flex flex-wrap justify-content-around">
                    <div class="card">
                      <h3>Agenzia</h3>
                      <p>{{ caricamento.agente_master }}</p>
                    </div>
                    <div class="card">
                      <h3>Agente</h3>
                      <p>{{ caricamento.agente_firmatario }}</p>
                    </div>
                    <div class="card" v-if="caricamento.rappresentante">
                      <h3>Rappresentante</h3>
                      <p>{{ caricamento.rappresentante }}</p>
                    </div>
                    <div class="card" v-if="caricamento.n_clienti > 0">
                      <h3>Client{{caricamento.n_clienti > 1 ? 'i' : 'e'}}</h3>
                      <p>{{ caricamento.denominazione_clienti }}</p>
                    </div>
                  </div>
                  <div class="card">
                    <h3>Data caricamento</h3>
                    <p>{{ moment(caricamento.data_caricamento).format('DD/MM/Y HH:mm') }}</p>
                  </div>
                  <p class="m-0">{{ caricamento }}</p>
                </AccordionTab>
              </Accordion>
            </AccordionTab>
          </Accordion>
          
        </div>
        
        <div class="card">
          <h3>Stati caricamenti</h3>
          <div class="flex flex-wrap justify-content-around">
            <div v-for="el of statistiche.stati_caricamenti" :key="el">
              <div class="card">
                <h4>{{el.name}}: {{ el.count }}</h4>
              </div>          
            </div>
          </div>
        </div>
        <div class="card">
          <h3>Firmati</h3>
          <div class="flex justify-content-around">
            <div v-for="el of statistiche.stati_firmati" :key="el">
              <div class="card">
                <h4>{{el.name}}: {{ el.count }}</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <h3>Numero forniture</h3>
          <div class="flex justify-content-around">
            <div v-for="(el, type) of statistiche.pp" :key="el">
              <div class="card" v-if="el.count > 0">
                <h4>{{type}}: {{el.count}}</h4>
                <Button v-if="el.data.length > 0" @click="openDetailsPp(el.data, type)" label="Visualizza forniture" />
              </div>          
            </div>
          </div>
        </div>
        <div class="card">
          <h3>Caricati</h3>
          <div class="flex justify-content-around">
            <div v-for="(els, type) of statistiche.stati_caricato" :key="type" class="card">
              <h4>{{ type }}</h4>
              <div class="flex flex-column align-items-center">
                <div v-for="el of els" :key="el.id">
                    <h4>{{el.name}}: {{ el.count }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
        Precheck: {{ statistiche.stati_precheck }}

        </div>
        <div class="card">
        TIMOE/TIMG: {{ statistiche.stati_timoe_timg }}

        </div>
        <div class="card">
        Switch: {{ statistiche.stati_switch }}

        </div>
        <div class="card">
          Agenti: {{ statistiche.agenti }}

        </div>
        <div class="card">
          Agenzie: {{ statistiche.agenti_master }}

        </div>
      </div>
    </TabPanel> -->
  </TabView>
  <Dialog v-model:visible="visibleDialogPp" modal header="Dettagli forniture" :style="{ width: '90%' }">
    <DataTable :value="data_pps">
      <Column field="matrice_id" header="#Id Matrice"></Column>
      <Column field="denominazione_cliente" header="Cliente"></Column>
      <Column header="Fornitura">
        <template #body="{data}">
          {{ data[type_pps] }}
        </template>
      </Column>
      <Column header="Caricato">
        <template #body="{data}">{{ getStatoCaricato(data.caricato) }}</template>
      </Column>
      <Column header="Precheck">
        <template #body="{data}">{{ getStatoPrecheck(data.precheck) }}</template>
      </Column>
      <Column header="Storico Precheck">
        <template #body="{data}">
          <div v-if="data.prechecks.length">
            {{ data.prechecks }}
          </div>
          <div v-else>
            Non ci sono precheck per questo punto di prelievo
          </div>
        </template>
      </Column>
    </DataTable>
  </Dialog>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import {ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Loader from "@/components/Loader.vue"
import { useToast } from 'primevue/usetoast';
import { useRoute, useRouter } from 'vue-router'

export default {
  components: {
    Loader
  },  
  setup () {
    // default setup
    const route = useRoute()
    const router = useRouter()
    const toast = useToast();
    const store = useStore()
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const loading = ref(false)
    const basePath = ref()
    const wizardPath = ref()
    const currentUser = ref(store.state.auth.user)
    const date = ref(new Date())
    const dates = ref([])
    const all_statistiche = ref([])
    const data_pps = ref([])
    const type_pps = ref()
    const visibleDialogPp = ref(false)
    const blacklist = ref()
    
    // custom setup
    const option = {
      Pod:{mask: 'aa999a99999999', placeholder: 'INSERISCI UN POD'},
      Pdr:{mask: '99999999999999', placeholder: 'INSERISCI UN PDR'}
    }
    const tooltip = {
      true: 'blocca',
      false: 'sblocca'
    }

    const stateSwitch = {
      1: 'In switch',
      2: 'Switchato',
      3: 'Switch annullato',
      4: 'Pratica',
      5: 'Annullato timoe/timg',
      6: 'In attesa dell\'accettazione switch',
      7: 'Annullato',
    }

    const option_toast = {
      true: {
        severity: 'success', detail: 'Operazione eseguita correttamente'
      },
      false: {
        severity: 'warn', detail: 'Operazione non eseguita correttamente'
      }
    }
    const supply_ee = ref('')
    const supply_gas = ref('')
    const selectedSupply = ref('Pod');
    const options = ref(['Pod', 'Pdr']);
    const items = ref([])
    const getPlaceholder = computed (()=>{
      return option[selectedSupply.value].placeholder
    })
    const canSearch = computed (()=>{
      let supply = selectedSupply.value == 'Pod' ? supply_ee.value : supply_gas.value
      return supply.length == 14
    })
    const is_caricabile = ref()
    const is_caricabile_stato_iniziale = ref()
    const stati = ref([])

    const getAllStati = async () => {
      await service.getAllStati()
      .then((res)=>{
        stati.value = res.items
      })
    }

    const searchSupply = () => {
      items.value = []
      loading.value = true
      let fd = new FormData();
      let supply = selectedSupply.value == 'Pod' ? supply_ee.value : supply_gas.value

      fd.append('supply', JSON.stringify(supply));
      fd.append('type_supply', JSON.stringify(selectedSupply.value));

      service.searchSupply(fd)
      .then((res) => {
        items.value = res.items.data
        blacklist.value = res.items.blacklist
        if (!items.value.length) {
          toast.add({severity:'warn', detail:'Non ci sono caricamenti per la fornitura inserita', life: 5000});
        }else{
          is_caricabile_stato_iniziale.value = computed_caricabile.value
          is_caricabile.value = computed_caricabile.value
        }
      }).finally(() => {
        loading.value = false
      })
    }
    const getIsInFornitura = (data) => {
      let in_fornitura = false
      let now = moment()
      
      if (data.data_fine) {
        in_fornitura = moment(now).isBefore(data.data_fine)
      }
      
      return in_fornitura
    }
    const has_items = computed (()=>{
      return items.value.length
    })

    const computed_caricabile = computed (()=>{
      let is_caricabile = true
      if (has_items.value) {
        for (let index = 0; index < items.value.length; index++) {
          if(!items.value[index].caricabile){
            is_caricabile = false
            break;
          } 
        }
      }
      return is_caricabile
    })

    const setSupply = () => {
      loading.value = true

      let ids = []
      items.value.forEach(item => {
        ids.push(item.id)
      })
      let fd = new FormData();
      fd.append('ids', JSON.stringify(ids));
      fd.append('type_supply', JSON.stringify(selectedSupply.value));
      fd.append('is_caricabile', is_caricabile.value);
      fd.append('pp', JSON.stringify(selectedSupply.value == 'Pod' ? supply_ee.value.toUpperCase() : supply_gas.value));

      service.setSupply(fd)
      .then((res) => {
        let result = Boolean(res.items)
        
        toast.add({severity: option_toast[result].severity, detail:option_toast[result].detail, life: 5000});
      }).finally(() => {
        initData()
        loading.value = false
      })
    }

    const initData = async () => {      
      supply_ee.value = ''
      supply_gas.value = ''
      items.value = []
      is_caricabile.value = null 
      is_caricabile_stato_iniziale.value = null
      blacklist.value = null
      basePath.value = await service.getBaseAdminUrl()
      wizardPath.value = await service.getBaseWizardUrl()
    }

    const getTooltip = () => {
      return tooltip[!is_caricabile.value]
    }

    const getStateSwitch = (data) => {
      let stato = stateSwitch[data.cod_state_switch]
      if (data.cod_state_switch == 1) {
        stato += ` dal ${moment(data.data_possibile_switch).format('DD/MM/YYYY HH:mm')}`
      }else if(data.cod_state_switch == 2){
        stato += ` per il ${moment(data.data_decorrenza_switch).format('DD/MM/YYYY')}`
      }else{
        let data_aggiornamento = data.data_aggiornamento_switch ?? data.data_creazione
        stato += ` aggiornato al ${moment(data_aggiornamento).format('DD/MM/YYYY HH:mm')}`
      }
      return stato
    }

    const goTo = async (evt, data, type_path) => {      
      let path
      let type_data
      switch (type_path) {
        case 'cliente':
          path = `clienti`
          type_data = `id_${type_path}`
          break;
        case 'numero':
          path = `clienti/fatture`
          type_data = type_path
          break;

        default:
          path = `${data.type_fornitura}s`
          type_data = `id_${data.type_fornitura}`
          break;
      }
      window.open(`${basePath.value}/ask/${path}/${data[type_data]}/dettagli`, '_blank')
    }
    const goToCaricamento = async (evt, data) => {
        console.log(evt, data, wizardPath.value)
        
      window.open(`${wizardPath.value}/caricamenti-multisito/${data.matrice_id}`, '_blank')
    }

    const getSeverityInlineMessage = (data) => {
      let severity = ''
      if (data.in_ask) {
        severity = 'error'
      }

      if (getIsInFornitura(data)){
        severity = 'success'
      }else if(data.data_presunta_switch != null) {
        severity = 'warn'
      }
      
      return severity
    }
    const getInlineMessage = (data) => {      
      let msg = ''
      if (data.in_ask) {
        msg = 'cessato il '+moment(data.data_fine).format('DD/MM/YYYY')
      }

      if (getIsInFornitura(data)){
        msg = 'in fornitura dal '+moment(data.data_inizio).format('DD/MM/YYYY')
      }else if(data.data_decorrenza_switch != null) {
        msg = 'in switch al '+moment(data.data_decorrenza_switch).format('DD/MM/YYYY')
      }else if(data.data_possibile_switch != null) {
        msg = 'switchabile dal '+moment(data.data_possibile_switch).format('DD/MM/YYYY HH:mm')
      }
      
      return msg
    }

    const downloadSwitchable = async () => {
      loading.value = true
      await service.downloadSwitchable()
        .finally(()=> {
          loading.value = false
        })        
    }
    const openDetailsPp = (data, type) => {
      type_pps.value = type == 'ee' ? 'pod' : 'pdr'
      data_pps.value = data
      visibleDialogPp.value = true
    }

    const getStatoCaricato = (code) => {
      return ([{id: 0, name: 'Non caricato'}, {id: 1, name: 'Caricato'}, {id: 2, name: 'Annullato'}].find(stato => stato.id == code)).name
    }
    const getStatoPrecheck = (code) => {
      return ([{id: 0, name: 'Non eseguito'}, {id: 1, name: 'OK'}, {id: 2, name: 'KO'}, {id: 3, name: 'Da rieseguire'}].find(stato => stato.id == code)).name
    }

    onMounted(() => {
      getAllStati()
      initData()
    })

    return {
      moment,
      loading,
      supply_ee,
      supply_gas,
      selectedSupply,
      options,
      getPlaceholder,
      canSearch,
      searchSupply,
      items,
      has_items,
      is_caricabile,
      is_caricabile_stato_iniziale,
      getTooltip,
      getStateSwitch,
      setSupply,
      initData,
      stati,
      goTo,
      getSeverityInlineMessage,
      getInlineMessage,
      downloadSwitchable,
      date,
      all_statistiche,
      data_pps,
      visibleDialogPp,
      openDetailsPp,
      type_pps,
      getStatoCaricato,
      getStatoPrecheck,
      goToCaricamento,
      blacklist
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.forniture-contrattualizzate {
  font-family: 'Montserrat', sans-serif;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 1.5rem;
}

.page-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.subtitle {
  color: #666;
  font-size: 1rem;
}

.action-section {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: flex-end;
}

.section-header {
  border-bottom: 1px solid #ddd;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
}

.section-header h3 {
  font-weight: 500;
  font-size: 1.3rem;
  color: #444;
}

.form-section, .results-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-weight: 500;
  color: #555;
}

.supply-type-selector {
  display: flex;
  justify-content: flex-start;
}

:deep(.p-selectbutton) {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

:deep(.p-selectbutton .p-button) {
  background-color: #f5f7fa;
  border-color: #e6e6e6;
  color: #555;
  padding: 0.4rem 1.5rem;
  font-weight: 500;
  transition: all 0.2s;
}

:deep(.p-selectbutton .p-button:hover) {
  background-color: #eef1f5;
}

:deep(.p-selectbutton .p-button.p-highlight) {
  background-color: #3498db;
  border-color: #3498db;
  color: white;
}

.search-bar {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

:deep(.search-bar .p-inputtext),
:deep(.search-bar .p-inputmask) {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0.7rem 1rem;
  flex-grow: 1;
  transition: all 0.2s;
}

:deep(.search-bar .p-inputtext:focus),
:deep(.search-bar .p-inputmask:focus) {
  border-color: #3498db;
  box-shadow: 0 0 0 1px rgba(52, 152, 219, 0.15);
}

:deep(.p-button) {
  background-color: #3498db;
  border-color: #3498db;
  padding: 0.7rem 1rem;
  font-weight: 500;
  border-radius: 4px;
  transition: background-color 0.2s;
}

:deep(.p-button:hover) {
  background-color: #2980b9;
  border-color: #2980b9;
}

:deep(.p-button.p-button-icon-only) {
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
}

.supply-id {
  color: #3498db;
  font-weight: 500;
}

.caricabile-toggle {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f9f9f9;
  padding: 0.8rem 1rem;
  border-radius: 4px;
  border: 1px solid #eee;
}

.toggle-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: 1rem;
}

:deep(.p-checkbox) {
  width: 20px;
  height: 20px;
}

:deep(.p-checkbox .p-checkbox-box) {
  border-radius: 3px;
}

:deep(.p-button.cliente-btn) {
  padding: 0;
  background: transparent;
  border: none;
  color: #3498db;
  font-weight: 500;
  text-decoration: none;
}

:deep(.p-button.cliente-btn:hover) {
  text-decoration: underline;
  background: transparent;
  border: none;
}

.status-messages {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

:deep(.p-inline-message) {
  padding: 0.7rem 1rem;
  border-radius: 4px;
}

:deep(.p-datatable) {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

:deep(.p-datatable-thead > tr > th) {
  background-color: #f5f7fa;
  padding: 0.8rem 1rem;
  font-weight: 500;
  color: #444;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.7rem 1rem;
  border-bottom: 1px solid #f0f0f0;
}

:deep(.p-datatable-tbody > tr:nth-child(even)) {
  background-color: #fafafa;
}

@media (max-width: 768px) {
  .search-bar {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .status-messages {
    flex-direction: column;
  }
  
  .caricabile-toggle {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .toggle-container {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}
</style>